import { defaultJobListFilter,type JobListFilter } from './jobListFilter';

export type JobListFilterQueryParams = {
  scope?: 'ALLY' | 'RETAIL';
  allyInspectionProvider?: 'CLICK_INS' | 'PAVE';
  lineOfBusiness?: 'E_CARS';
  isAutomotive?: boolean;
};

export const jobListFilterQueryParams = (
  filter: JobListFilter = defaultJobListFilter
): JobListFilterQueryParams => {
  switch (filter.scope) {
    case 'ALL':
      return {};
    case 'ALLY': {
      switch (filter.ally) {
        case 'ALL':
          return { scope: 'ALLY' };
        case 'CLICK_INS':
          return { allyInspectionProvider: 'CLICK_INS' };
        case 'PAVE':
          return { allyInspectionProvider: 'PAVE' };
        case 'E_CARS':
          return { lineOfBusiness: 'E_CARS' };
        default: {
          const unreachable: never = filter.ally;
          return unreachable;
        }
      }
    }
    case 'RETAIL': {
      switch (filter.retail) {
        case 'ALL':
          return { scope: 'RETAIL' };
        case 'AUTOMOTIVE':
          return { scope: 'RETAIL', isAutomotive: true };
        case 'NON_AUTOMOTIVE':
          return { scope: 'RETAIL', isAutomotive: false };
        default: {
          const unreachable: never = filter.retail;
          return unreachable;
        }
      }
    }
    default: {
      const unreachable: never = filter.scope;
      return unreachable;
    }
  }
};

export const jobListFilterIsActive = (filter: JobListFilter): boolean =>
  filter.scope !== defaultJobListFilter.scope ||
  filter.ally !== defaultJobListFilter.ally ||
  filter.retail !== defaultJobListFilter.retail;
